import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { InternalApiAlertsPage, InternalApiMonitoringAlert } from '../api-internal';

export interface AlertsState {
  alerts: InternalApiMonitoringAlert[];
  page: number;
  size: number;
  total: number;
}

const initialState: AlertsState = {
  alerts: [],
  page: 0,
  size: 20,
  total: 0,
};

const alertsSlice = createSlice({
  name: 'alerts',
  initialState,
  reducers: {
    fetchAlertsSuccess: (state, action: PayloadAction<InternalApiAlertsPage>) => {
      state.alerts = action.payload.content;
      state.total = action.payload.total;
      state.page = action.payload.number;
    },
    updateAlertSuccess: (state, action: PayloadAction<InternalApiMonitoringAlert>) => {
      state.alerts = state.alerts.map((item) => {
        if (item.id === action.payload.id) {
          return action.payload;
        }

        return item;
      });
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = alertsSlice;
// Extract and export each action creator by name
export const { fetchAlertsSuccess, updateAlertSuccess, setPage } = actions;
// Export the reducer, either as a default or named export
export default reducer;
